import { createSlice } from "@reduxjs/toolkit";
import { FirebaseError } from "firebase/app";
import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { logError } from "../../../utils/customLogger";
import { AppDispatch } from "../../store/store";
import { CmmFormConfigModel } from "../../../data-model/cmmFormConfigModel";
export interface CmmFormConfigSliceModel {
  data?: CmmFormConfigModel[];
  loading: boolean;
  error: string | null;
}

const initialState: CmmFormConfigSliceModel = {
  data: undefined,
  loading: false,
  error: null,
};

const cmmFormConfigSlice = createSlice({
  name: "cmmFormConfigSlice",
  initialState,
  reducers: {
    fetchCmmFormConfigStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCmmFormConfigSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchCmmFormConfigFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    resetCmmFormConfig(state) {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { resetCmmFormConfig } = cmmFormConfigSlice.actions;

export const fetchAllCmmFormConfiguration =
  () => async (dispatch: AppDispatch) => {
    dispatch(cmmFormConfigSlice.actions.fetchCmmFormConfigStart());
    try {
      const response = await FirestoreService.getAllDocuments(
        FirestoreCollectionReference.cmmFormConfig(),
      );
      dispatch(cmmFormConfigSlice.actions.fetchCmmFormConfigSuccess(response));
    } catch (error) {
      const firebaseError = error as FirebaseError;
      logError(firebaseError, "Error fetching form options");
      dispatch(
        cmmFormConfigSlice.actions.fetchCmmFormConfigFailure(
          firebaseError.message,
        ),
      );
    }
  };

export default cmmFormConfigSlice.reducer;
